<template>
    <v-sheet>
        <lecture-category-select
            v-model="form._category"
            v-bind="{
                ...attrs_input,
                categories,
            }"
            @input="emit"
        />
    </v-sheet>
</template>

<script>
import { initLecture } from "@/store/lecture/lecture.inits";
import { attrs_input } from "@/assets/variables";
import lectureCategorySelect from "@/components/dashboard/company/lecture/category/lecture-category-select.vue";
import { mapActions, mapState } from "vuex";

export default {
    components: { lectureCategorySelect },
    props: {
        value: { type: Object, default: initLecture },
    },
    data: () => ({
        form: initLecture(),

        attrs_input,
    }),
    computed: {
        ...mapState("lecture/category", { categories: "items" }),
    },
    methods: {
        ...mapActions("lecture/category", { getCategories: "getItems" }),
        init() {
            if (this.categories.length < 1) {
                this.getCategories();
            }
        },
        sync() {
            this.form = initLecture(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.init();
        this.sync();
    },
};
</script>

<style></style>
